import { z } from 'zod';
import { SHIFT_STATES } from '../constants';
import { idSchema, minutesSchema, updatedAtSchema } from './common';

export const shiftInputSchema = z
  .object({
    postId: idSchema,
    eventDayId: idSchema,
    fromMin: minutesSchema,
    toMin: minutesSchema,
    volunteerId: idSchema.nullable().default(null),
    state: z.enum(SHIFT_STATES).default('open'),
    note: z.string().trim().max(1000).default(''),
    meetMin: minutesSchema.nullable().default(null),
    meetPlace: z.string().trim().max(300).default(''),
    /**
     * Silent edit (SPEC §1.1B): when true, a material change does NOT bump the
     * volunteer's schedule version / reset their confirmation.
     */
    silent: z.boolean().default(false),
  })
  .refine((s) => s.fromMin < s.toMin, { message: 'fromMin must be before toMin' });

export const shiftUpdateSchema = z.object({
  postId: idSchema.optional(),
  eventDayId: idSchema.optional(),
  fromMin: minutesSchema.optional(),
  toMin: minutesSchema.optional(),
  volunteerId: idSchema.nullable().optional(),
  state: z.enum(SHIFT_STATES).optional(),
  note: z.string().trim().max(1000).optional(),
  meetMin: minutesSchema.nullable().optional(),
  meetPlace: z.string().trim().max(300).optional(),
  silent: z.boolean().default(false),
  updatedAt: updatedAtSchema,
});

export const shiftSchema = z.object({
  id: idSchema,
  postId: idSchema,
  eventDayId: idSchema,
  fromMin: minutesSchema,
  toMin: minutesSchema,
  volunteerId: idSchema.nullable(),
  state: z.enum(SHIFT_STATES),
  note: z.string(),
  meetMin: minutesSchema.nullable(),
  meetPlace: z.string(),
  createdAt: z.iso.datetime({ offset: true }),
  updatedAt: updatedAtSchema,
});

export type ShiftInput = z.infer<typeof shiftInputSchema>;
export type Shift = z.infer<typeof shiftSchema>;
